module.exports = __webpack_public_path__ + "img/35.db7e6721.jpg";